export class UseEmptyContextError extends Error {
  constructor(contextName = '') {
    const errorMessage = `use${contextName}Context must be wrapped in a ${contextName}Context Provider`;
    super(errorMessage);
  }
}
